export const state = {
  versionIOS: ''
}
export const mutations = {
  inputVersion(state, payload) {
    state.versionIOS = payload
  },
  setVersion(state, response) {
    if (response.data['data'] == null) {
      response.data['data'] = ''
    }
    state.versionIOS = response.data['data']['version']
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/systemAdminModules/forcedUpdateModules/forcedUpdateMutation.js